import { Theme } from "@mui/material";

export const businessProfileStyles = {
  mainContainer: (theme: Theme) => ({
    width: {
      xs: "100vw",
      sm: "90vw",
      md: "85vw",
    },

    fontFamily: theme.typography.fontFamily,
  }),
  loadingContainer: {
    height: "90vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  loadingAvailabilitiesContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "350px",
  },
  upperContainer: {
    marginTop: "20px",
    marginBottom: {
      xs: "8px",
      sm: "8px",
    },
    display: "flex",
    flexDirection: "column",
    gap: {
      xs: "0.2rem",
    },
    borderRadius: "0.5rem",
    position: "relative",
  },
  outerContainer: {
    marginTop: {
      xs: "12px",
    sm: "12px",
    },
  },
  datePickerContainer: {
    marginLeft: '8px',
  },
  listButton: { position: "absolute", top: 0, left: 10 },
  upperBusinessNameText: {
    fontWeight: "bold",
    color: "#000",
    textAlign: "center",
    width: "93%",
    margin: "0 auto",
    paddingBottom: {
      xs: "2px",
      sm: "7px",
    },
    paddingTop: {
      md: "1rem",
    },
    paddingLeft: "7px",
    paddingRight: "7px",
    fontSize: {
      xs: "24px",
      sm: "2.75rem",
    },
  },
  upperBusinessAddressText: {
    color: "#000",
    fontSize: {
      xs: "13px",
      sm: "13px",
    },
    lineHeight: "18.5px",
    letterSpacing: "0.203px",
    fontWeight: 400,
  },
  border: {
    borderBottom: "1px solid #000",
    marginTop: "-5px",
    width: "93%",
    margin: "0 auto",
  },
  imageContainer: {
    width: "100%",
    height: {
      xs: "220px",
      md: "45vh", 
    },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  mainHeading: {
    fontWeight: "600",
    color: "#000",
    textAlign: "left",
    marginTop: "16px",
    marginBottom: "4px",
    paddingTop: {
      md: "1rem",
    },
    fontSize: {
      xs: "24px",
      sm: "24px",
    },
  },
  availabilitiesHeading: {
    color: "#000",
    fontSize: "30px",
    lineHeight: "35px",
    fontWeight: 700,
    marginLeft: '8px',
    marginTop: '1rem',
  },
  locationContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    width: "fit-content",
    margin: "0 auto"

  },
  locationText: {
    color: "#595959",
    fontSize: {
      xs: "13px",
      sm: "1.25rem",
    },
    paddingY: {
      md: "0.5rem",
    },
    lineHeight: "18.5px",
    letterSpacing: "0.203px",
    fontWeight: 400,

  },
  chipStyles: {
    margin: "0 0.5rem 0.5rem 0",
    border: "1px solid #000",
  },
  contactInfoContainer: {
    marginTop: "1rem",
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    backgroundColor: "#FFF",
    border: "1px solid black",
    borderRadius: "0.5rem",
  },
  contactInfoSingleContainer: { display: "flex", flexDirection: "column" },
  nameContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },

  greenButton: {
    backgroundColor: "green",
    color: "white",
    fontSize: "17px",
    fontWeight: "600",
    minWidth: "100%",
    marginTop: "1rem",
    "&:hover": {
      backgroundColor: "green",
      boxShadow: "none",
    },
  },

  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "10px",
  },

  whiteButton: {
    borderColor: "black",
    color: "black",
    "&:hover": { backgroundColor: "#f0f0f0" },
    fontSize: { xs: "15px", sm: "17px" },
    fontWeight: "600",
    minWidth: "49%",
  },
  contactTypo: {
    textDecoration: "underline",
    cursor: "pointer",
  },
  noFoundContainer: {
    minHeight: "30vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  noFoundText: {
    textAlign: "center",
    marginTop: "20px",
    fontSize: "18px",
    color: "#000",
    fontWeight: 500,
  },
  availabilityContainer: (isScreenBreak: boolean) => ({
    ...(isScreenBreak && {
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      overflowX: "auto",
      gap: "0.5rem",
      paddingBottom: "0.5rem",

      /* scrollbar only relevant when overflow exists */
      scrollbarWidth: "auto",
      "&::-webkit-scrollbar": { height: 8 },
      "&::-webkit-scrollbar-thumb": { backgroundColor: "#ccc", borderRadius: 4 },
      "&::-webkit-scrollbar-track": { backgroundColor: "#ffffff" }
    }),

    ...(!isScreenBreak && {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
      gap: "1rem"
    }),

    marginTop: "20px",
    zIndex: 1,
  }),
  availabilityItemWrapper: (isScreenBreak: boolean, itemCount: number) => ({
    flex: "0 0 auto",
    ...(isScreenBreak
      ? {
          minWidth: 260,
          width: itemCount === 1 ? "100%" : "88vw",
          maxWidth: "88vw",
          marginLeft: itemCount === 1 ? "8px" : 0,
        }
      : {
          minWidth: 0,
          width: "100%",
          maxWidth: "none",
          marginLeft: 0,
        }),
  }),
  businessContainer: {
    marginTop: "10px",
    marginBottom: {
      xs: "5px",
      sm: "2px",
    },
    display: "flex",
    flexDirection: "column",
    gap: {
      xs: "0.2rem",
    },
    borderRadius: "0.5rem",
  },
  headlineText: {
    color: "#0D0D0D",
    lineHeight: "18.5px",
    paddingHorizontal: "10px",
    fontSize: {
      xs: "13px",
      sm: "1.1rem",
    },
    textAlign: "center",
    fontStyle: 'italic',
  },
};
